import { render, staticRenderFns } from "./help-function.vue?vue&type=template&id=1add4f52&"
import script from "./help-function.vue?vue&type=script&lang=js&"
export * from "./help-function.vue?vue&type=script&lang=js&"
import style0 from "./help-function.vue?vue&type=style&index=0&id=1add4f52&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports